import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 48, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Chapter = ({ number, label, dark = false }) => (
  <Reveal className="flex items-center gap-4 mb-6">
    <span
      className={`font-serif italic text-lg ${dark ? "text-[#c9006f]" : "text-[#a3005a]"}`}
    >
      {number}
    </span>
    <span className="gold-rule w-16" />
    <span
      className={`uppercase tracking-[0.28em] text-xs font-semibold ${
        dark ? "text-white/60" : "text-[#91008d]/70"
      }`}
    >
      {label}
    </span>
  </Reveal>
);
